import { render } from "./DiagnosticLayout.vue?vue&type=template&id=42381b69&scoped=true"
import script from "./DiagnosticLayout.vue?vue&type=script&lang=js"
export * from "./DiagnosticLayout.vue?vue&type=script&lang=js"

import "./DiagnosticLayout.vue?vue&type=style&index=0&id=42381b69&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42381b69"]])

export default __exports__